import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import useFetchCrmObjectType from 'framework-listing-lib/hooks/useFetchCrmObjectType';
import { useLowercaseCrmObjectTypeName } from 'framework-listing-lib/internal/hooks/useCrmObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ListingLibTitleWithCounts({
  title
}) {
  const {
    lowerCaseObjectTypeNamePlural: objectTypeNamePlural,
    lowerCaseObjectTypeNameSingular: objectTypeNameSingular,
    capitalizedObjectTypeNamePlural,
    capitalizedObjectTypeNameSingular
  } = useLowercaseCrmObjectTypeName();
  const {
    loading,
    data
  } = useFetchCrmObjectType();
  const totalLists = useMemo(() => loading || !data ? '--' : data.total, [data, loading]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [title, /*#__PURE__*/_jsx(Text, {
      whiteSpace: "nowrap",
      as: "div",
      typography: "heading-25",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkListingLib.title.totalAssets",
        options: {
          assetNameSingular: objectTypeNameSingular,
          assetNamePlural: objectTypeNamePlural,
          capitalizedAssetNameSingular: capitalizedObjectTypeNameSingular,
          capitalizedAssetNamePlural: capitalizedObjectTypeNamePlural,
          count: totalLists
        }
      })
    })]
  });
}